<template>
  <translation-modal v-if="translationModalState" />
  <PdfViewerDialog v-if="previewDocumentState.open" />
  <GlossaryViewerDialog v-if="glossaryModalState" />
  <FilesViewerDialog v-if="filesModalState" />
</template>

<script>
import FilesViewerDialog from '~/components/files/FilesViewerDialog.vue';
import GlossaryViewerDialog from '~/components/glossary/GlossaryViewerDialog.vue';
import PdfViewerDialog from '~/components/pdfViewer/PdfViewerDialog.vue';
import TranslationModal from '~/components/conversation/translation/TranslationModal.vue';
import useModals from '~/composables/useModals';

export default {
  name: 'FilesGlossaryDialogs',
  components: {
    TranslationModal,
    PdfViewerDialog,
    GlossaryViewerDialog,
    FilesViewerDialog,
  },

  setup() {
    const { filesModalState, glossaryModalState, previewDocumentState, translationModalState } = useModals();

    return {
      filesModalState,
      glossaryModalState,
      previewDocumentState,
      translationModalState,
    };
  },
};
</script>
